import angular from 'angular';
import { MeurhSolicitacoesalteracoesdadossalariaisService } from './solicitacoesalteracoesdadossalariais.service';
import { ListagemService } from '../../../shared/services/listagem.service';

export const MeurhSolicitacoesalteracoesdadossalariaisListRouting = ['$stateProvider', function ($stateProvider: angular.ui.IStateProvider) {
    const resolve = {
        'entity': [
            'MeurhSolicitacoesalteracoesdadossalariaisService',
            'ListagemService',
            '$rootScope',
            '$stateParams',
            '$state',
            '$q',
            function (
                entityService: MeurhSolicitacoesalteracoesdadossalariaisService,
                listagemService: ListagemService,
                $rootScope: angular.IRootScopeService & {
                    session: any,
                    liberadoTela: (arg: string) => boolean
                },
                $stateParams: angular.ui.IStateParamsService,
                $state: angular.ui.IStateService,
                $q: angular.IQService
            ) {
                if (!$stateParams['solicitacao']) {
                    return $q<void>(() => $state.go('meurh_solicitacoesalteracoestiporecebimento'));
                }

                return entityService.get($stateParams['solicitacao'])
                    .then((data) => {
                        const visibilidadeLiberada = $rootScope.liberadoTela('LIBERAR_REFATORACAO_VISIBILIDADE');
                        const empresaNoGrupo = listagemService.getEmpresa(data.empresa.empresa);
                        const mesmoEstabelecimento = data.estabelecimentoobj.estabelecimento === $rootScope.session.entities.estabelecimento.estabelecimento;

                        const deveRedirecionar = (
                            (visibilidadeLiberada && !empresaNoGrupo) ||
                            (!visibilidadeLiberada && !mesmoEstabelecimento)
                        );

                        if (deveRedirecionar) {
                            return $q(() => $state.go('meurh_solicitacoesalteracoestiporecebimento'));
                        }

                        return data;
                    })
                    .catch((error) => {
                        if (error.status === 404) {
                            return $q(() => {
                                if ($state.href('meurh_solicitacoesalteracoestiporecebimento_not_found', $stateParams)) {
                                    $state.go('meurh_solicitacoesalteracoestiporecebimento_not_found', $stateParams);
                                } else {
                                    $state.go('not_found', $stateParams);
                                }
                            });
                        }

                        return $q.reject(error);
                    });
            }
        ]
    };

    $stateProvider
        .state('meurh_solicitacoesalteracoestiporecebimento', {
            url: '/solicitacoes/alteracaorecebimento?q?tipo',
            template: require('html-loader!./index/solicitacoesalteracoesdadossalariais.index.html'),
            controller: 'Meurh\SolicitacoesalteracoesdadossalariaisIndexController',
            controllerAs: 'mrh_alteracoesdadossalariais_lst_cntrllr',
            reloadOnSearch: false
        })
        .state('meurh_solicitacoesalteracoestiporecebimento_new', {
            parent: 'meurh_solicitacoesalteracoestiporecebimento',
            url: '/new',
            template: require('html-loader!./new/solicitacoesalteracoesdadossalariais.new.html'),
            controller: 'MeurhSolicitacoesalteracoesdadossalariaisNewController',
            controllerAs: 'mrh_alteracoesdadossalariais_frm_nw_cntrllr'
        })
        .state('meurh_solicitacoesalteracoestiporecebimento_show', {
            parent: 'meurh_solicitacoesalteracoestiporecebimento',
            url: '/:solicitacao?path',
            resolve,
            template: require('html-loader!./show/solicitacoesalteracoesdadossalariais.show.html'),
            controller: 'MeurhSolicitacoesalteracoesdadossalariaisShowController',
            controllerAs: 'mrh_alteracoesdadossalariais_frm_shw_cntrllr'
        });
    }
];
